export const categories = [
  {
    slug: 'caoping-xuanzhong',
    name: '草坪选种',
    description: '了解不同草坪品种的特性与适用场景，为您的庭院挑选最合适的草坪类型。',
    icon: 'ri-seedling-line',
    articles: ['article-1', 'article-2', 'article-13'],
  },
  {
    slug: 'caoping-yanghu',
    name: '草坪养护',
    description: '掌握科学的草坪养护技巧，让草坪四季常青、健康茂盛。',
    icon: 'ri-plant-line',
    articles: ['article-3', 'article-4', 'article-14'],
  },
  {
    slug: 'huayuan-sheji',
    name: '花园设计',
    description: '从布局规划到风格定位，打造独具魅力的私家花园空间。',
    icon: 'ri-layout-masonry-line',
    articles: ['article-5', 'article-6', 'article-15'],
  },
  {
    slug: 'jingguan-dapei',
    name: '景观搭配',
    description: '草坪与花境、水景、石材的和谐搭配，营造丰富层次感。',
    icon: 'ri-image-line',
    articles: ['article-7', 'article-8', 'article-16'],
  },
  {
    slug: 'tingyuan-lvhua',
    name: '庭院绿化',
    description: '从阳台到屋顶，不同空间的绿化方案让绿色无处不在。',
    icon: 'ri-home-heart-line',
    articles: ['article-9', 'article-10'],
  },
  {
    slug: 'huwai-kongjian',
    name: '户外空间',
    description: '打造功能与美感兼具的户外生活区域，享受庭院时光。',
    icon: 'ri-sun-line',
    articles: ['article-11', 'article-12'],
  },
];